import { useEffect } from 'react'
import { floraMessage } from '@grupoboticario/flora-react-utils'
import { FloraRadioProps } from './types'

export const useFloraRadio = ({ id, label, 'aria-label': ariaLabel }: FloraRadioProps) => {
  useEffect(() => {
    if (label && ariaLabel && label !== ariaLabel) {
      floraMessage({
        type: 'log',
        category: 'accessibility',
        status: 'warn',
        message: `O input com id ${id} possui label e aria-label com valores diferentes. Utilize apenas um desses rótulos ou o mesmo valor em ambos.`,
      })
    }
  }, [id, label, ariaLabel])
}
